require('core-js/es/object'); // for IE11
require('core-js/es/number/is-finite'); // for IE11
require('core-js/es/number/is-integer'); // for IE11
require('core-js/es/number/is-nan'); // for IE11
require('core-js/es/number/parse-int'); // for IE11
require('core-js/es/number/parse-float'); // for IE11
require('core-js/es/promise'); // for IE11
require('core-js/es/array'); // for IE11, some functions are not supported: fill, from, findIndex, includes, flatMap etc.
require('core-js/es/string'); // for IE11, some functions are not supported: includes, startsWith, padStart, padEnd, etc.
require('core-js/es/symbol'); // for IE11
require('core-js/es/math/trunc'); // for IE11
require('core-js/es/map'); // for IE11 (used by React 16)
require('core-js/es/set'); // for IE11 (used by React 16)

require('core-js/web/dom-collections'); // for IE11 and Edge < 16, forEach() and iterators over NodeList are not supported there

// Weak Map - for IE11 (without this polyfill there were some issues
// with google maps API which were killing javascript on product page)
require('core-js/es/weak-map');

require('classlist-polyfill');
